import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import { useLogout } from '../hooks/useLogout';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { CartContext } from '../../context/CartContext';


const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
 
  const [loggedIn, setLoggedIn] = useState(false); 
  const {user} = useAuthContext();
  const {logout} = useLogout()
  const {cartItems} = useContext(CartContext)
  const cartIcon = !cartItems ? <ShoppingCartOutlinedIcon/> : <ShoppingCartIcon/>


  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const handleLogin = () => {
    // Replace this with the appropriate login logic
    setLoggedIn(true);
  };

  const handleLogout = () => {
    // Replace this with the appropriate logout logic
    logout()
  };


  return (
    <nav className="navbar">
      <div className="navbar__logo">Fashion Forward</div>
      <div className={`navbar__menu ${menuOpen ? 'open' : ''}`}>
        <ul>
    <Link to="">    <li>Home</li> </Link>  
    <Link to="">    <li>Men</li> </Link>  
    <Link to="">    <li>Women</li> </Link>  
    <Link to="">    <li>Accessories</li> </Link>  
        </ul>
      </div>
     
      <div className={`navbar__hamburger ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className="navbar__actions">
        {user ? (
          <div>
         <Link to="/cart">    {cartIcon} </Link>  
        <button onClick={handleLogout} className='navBtn'>Logout</button>
          </div>
        ) : (

          <div>
         <Link to="/cart">    {cartIcon} </Link>  
         <Link to="/signupuser" className='navBtn'>Signup/Login</Link>
          </div>
         
        )}
      </div>
    </nav>
  );
};

export default Navbar;
